import createIcon from '../../createIcon';

/**
 * @component @name EuroSymbol
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTguNUMxMi40OSAxOC41IDEwLjMyIDE3LjA4IDkuMjQgMTVIMTVWMTNIOC41OEM4LjUzIDEyLjY3IDguNSAxMi4zNCA4LjUgMTJDOC41IDExLjY2IDguNTMgMTEuMzMgOC41OCAxMUgxNVY5SDkuMjRDMTAuMzIgNi45MiAxMi41IDUuNSAxNSA1LjVDMTYuNjEgNS41IDE4LjA5IDYuMDkgMTkuMjMgNy4wN0wyMSA1LjNDMTkuNDEgMy44NyAxNy4zIDMgMTUgM0MxMS4wOCAzIDcuNzYgNS41MSA2LjUyIDlIM1YxMUg2LjA2QzYuMDIgMTEuMzMgNiAxMS42NiA2IDEyQzYgMTIuMzQgNi4wMiAxMi42NyA2LjA2IDEzSDNWMTVINi41MkM3Ljc2IDE4LjQ5IDExLjA4IDIxIDE1IDIxQzE3LjMxIDIxIDE5LjQxIDIwLjEzIDIxIDE4LjdMMTkuMjIgMTYuOTNDMTguMDkgMTcuOTEgMTYuNjIgMTguNSAxNSAxOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EuroSymbol = createIcon('EuroSymbol', [
  [
    'path',
    {
      d: 'M15 18.5C12.49 18.5 10.32 17.08 9.24 15H15V13H8.58C8.53 12.67 8.5 12.34 8.5 12C8.5 11.66 8.53 11.33 8.58 11H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.51 6.52 9H3V11H6.06C6.02 11.33 6 11.66 6 12C6 12.34 6.02 12.67 6.06 13H3V15H6.52C7.76 18.49 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z',
      key: '1k67yr',
    },
  ],
]);

export default EuroSymbol;
